import { render, staticRenderFns } from "./TierBeneficiary.vue?vue&type=template&id=57e77080&scoped=true&"
import script from "./TierBeneficiary.vue?vue&type=script&lang=js&"
export * from "./TierBeneficiary.vue?vue&type=script&lang=js&"
import style0 from "./TierBeneficiary.vue?vue&type=style&index=0&id=57e77080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e77080",
  null
  
)

export default component.exports